<template>
  <div>
    <MemberProfile
      class="my-4"
      fromSection="administration"
      :updateRole="roleHasChanged"
    />
    <MemberAccessGroups
      v-if="hasPermission('accessGroups.view')"
      class="mb-4"
      :updatedRole="isRoleChanged"
      :resetRoleChanged="resetRoleChanged"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MemberProfile from '@/views/member/MemberProfile.vue';
import MemberAccessGroups from '@/views/member/MemberAccessGroups.vue';

export default {
    components: {
        MemberProfile,
        MemberAccessGroups,
    },
    data() {
        return {
            isRoleChanged: false,
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
        ]),
    },
    methods: {
        roleHasChanged() {
            this.isRoleChanged = true;
        },
        resetRoleChanged() {
            this.isRoleChanged = false;
        },
    },
};
</script>
